// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3MUUp","textarea":"styles_textarea__2pwSn"};